import React, { useEffect, useState } from 'react'
import { Alert, Row } from 'shards-react'

export default function ConnectionErrorAlert() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => window.addEventListener('ameConnectionError', () => setIsVisible(true)), [])

    const closeAlert = () => setIsVisible(false)

    return (
        <Row>
            {isVisible && (
                <Alert
                    theme="danger"
                    dismissible={() => closeAlert()}
                    className="w-100 m-0"
                    style={{ position: 'fixed', top: 0, left: 0, zIndex: '9999' }}
                >
                    Ops! Ocorreu um problema com a internet.
                </Alert>
            )}
        </Row>
    )
}
